export default "__VITE_ASSET__DseuQj5n__"